module.exports = __webpack_public_path__ + "static/media/sf_attraction_alcatraz.0324b2dc.jpg";